import React from 'react';
import type {
	PluggableItem,
	ForgePluggableEntity,
	ConnectPluggableEntity,
} from '../../services/query/index.tsx';
import { ConnectDropdownItem } from './connect-dropdown-item/index.tsx';
import { ForgeDropdownItemWithErrorBoundary as ForgeDropdownItem } from './forge-dropdown-item/index.tsx';

export const DropdownItemWithApps = (props: { item: PluggableItem; totalCount: number }) => {
	if (isForgeProps(props)) {
		return <ForgeDropdownItem {...props} />;
	}
	if (isConnectProps(props)) {
		return <ConnectDropdownItem {...props} />;
	}
	return null;
};

export type ForgeProps = { item: ForgePluggableEntity; totalCount: number };
export type ConnectProps = { item: ConnectPluggableEntity; totalCount: number };

function isForgeProps(props: { item: PluggableItem; totalCount: number }): props is ForgeProps {
	return props.item.type === 'forge';
}

function isConnectProps(props: { item: PluggableItem; totalCount: number }): props is ConnectProps {
	return props.item.type === 'connect';
}
